module.exports = __webpack_public_path__ + "img/energy3.d0bf44d8.png";